import { clsx } from 'clsx';
import { useState, useEffect, forwardRef, Suspense, lazy } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { S as Sizes } from './common-DBpCdW70.esm.js';

/*
  *
  * DON'T MODIFY THIS FILE IT'S AUTO GENERATED
  * See: `scripts/generate-flags-metadata.mjs`
  *
  */
const DETAILED_FLAG_CODES = ['zm', 'va', 'uy', 'us', 'ug', 'tw', 'tv', 'tm', 'sv', 'sm', 'si', 'sg', 'py', 'pt', 'ph', 'pe', 'pa', 'om', 'nz', 'np', 'ni', 'mz', 'my', 'mx', 'mt', 'mh', 'md', 'ls', 'lk', 'li', 'ki', 'ke', 'je', 'in', 'im', 'hr', 'hn', 'hm', 'hk', 'gt', 'gi', 'gg', 'fj', 'eur', 'es', 'eg', 'do', 'cn', 'by', 'br', 'bn', 'bf', 'ba', 'az', 'au', 'ar', 'an', 'am', 'al', 'ad'];

const unknownFlagName = 'wise';
const Flag = ({
  code,
  intrinsicSize = 64,
  className = undefined,
  loading = 'lazy'
}) => {
  const [fallback, setFallback] = useState(null);
  useEffect(() => {
    setFallback(null);
  }, [code]);
  const detailed = intrinsicSize >= 150;
  // Only get detailed svg if we know it exists, to avoid the performance hit of failing requests
  const name = fallback !== 'unknown' ? `${code.toLowerCase()}${fallback == null && detailed && DETAILED_FLAG_CODES.includes(code.toLowerCase()) ? '-detailed' : ''}` : unknownFlagName;
  return /*#__PURE__*/jsx("img", {
    className: clsx(`wds-flag wds-flag-${name}`, className),
    src: process.env.NODE_ENV === 'web-art-dev' ? `${name}.svg` : `https://wise.com/web-art/assets/flags/${name}.svg`,
    loading: loading,
    alt: "",
    width: intrinsicSize,
    height: intrinsicSize,
    onError: () => {
      setFallback(prev => prev == null && detailed ? 'simple' : 'unknown');
    }
  });
};

const imageSizes = {
  [Sizes.SMALL]: 200,
  [Sizes.MEDIUM]: 300,
  [Sizes.LARGE]: 500
};
const Illustration = /*#__PURE__*/forwardRef(({
  id,
  name,
  alt = '',
  loading = 'eager',
  className,
  size = Sizes.MEDIUM,
  disablePadding = false
}, ref) => {
  const {
    SMALL,
    MEDIUM
  } = Sizes;
  return name ? /*#__PURE__*/jsxs("picture", {
    children: [size === Sizes.LARGE || size === Sizes.MEDIUM ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("source", {
        width: imageSizes[SMALL],
        height: imageSizes[SMALL],
        media: "(max-width: 575px)",
        srcSet: `${defineSrc$1(name, SMALL, '1x')}, ${defineSrc$1(name, SMALL, '2x')} 2x`
      }), size !== Sizes.MEDIUM ? /*#__PURE__*/jsx("source", {
        width: imageSizes[MEDIUM],
        height: imageSizes[MEDIUM],
        media: "(max-width: 992px)",
        srcSet: `${defineSrc$1(name, MEDIUM, '1x')}, ${defineSrc$1(name, MEDIUM, '2x')} 2x`
      }) : null]
    }) : null, /*#__PURE__*/jsx("img", {
      id: id,
      ref: ref,
      alt: alt,
      "data-testid": `wds-${name}-illustration`,
      className: clsx(`wds-illustration wds-illustration-${name}`, className, !disablePadding && 'wds-illustration-padding'),
      loading: loading,
      src: defineSrc$1(name, size, '1x'),
      srcSet: `${defineSrc$1(name, size, '2x')} 2x`,
      width: imageSizes[size],
      height: imageSizes[size]
    })]
  }) : null;
});
function defineSrc$1(illustration, size, descriptor) {
  return `https://wise.com/web-art/assets/illustrations/${illustration}-${size}@${descriptor}.webp`;
}

/*
  *
  * DON'T MODIFY THIS FILE IT'S AUTO GENERATED
  * See: `scripts/generate-i10s-metadata.mjs`
  *
  */
var Assets;
(function (Assets) {
  Assets["API_INTEGRATIONS_BUSINESS"] = "api-integrations-business";
  Assets["APP_MARKETPLACE_BUSINESS"] = "app-marketplace-business";
  Assets["BACKPACK"] = "backpack";
  Assets["BATCH_PAYMENTS_BUSINESS"] = "batch-payments-business";
  Assets["BELL"] = "bell";
  Assets["BELL_BUSINESS"] = "bell-business";
  Assets["BRIEFCASE"] = "briefcase";
  Assets["BRIEFCASE_BUSINESS"] = "briefcase-business";
  Assets["BRIEFCASE_SCAM"] = "briefcase-scam";
  Assets["BUSINESS_CARD"] = "business-card";
  Assets["BUSINESS_CARD_BUSINESS"] = "business-card-business";
  Assets["CALCULATOR_BUSINESS"] = "calculator-business";
  Assets["CALENDAR"] = "calendar";
  Assets["CALENDAR_BUSINESS"] = "calendar-business";
  Assets["CARD"] = "card";
  Assets["CARD_BUSINESS"] = "card-business";
  Assets["CHECK_MARK"] = "check-mark";
  Assets["CHECK_MARK_BUSINESS"] = "check-mark-business";
  Assets["CLOSED_WINDOW"] = "closed-window";
  Assets["COIN_PILE_DOWN"] = "coin-pile-down";
  Assets["COIN_PILE_DOWN_BUSINESS"] = "coin-pile-down-business";
  Assets["COIN_PILE_UP"] = "coin-pile-up";
  Assets["COIN_PILE_UP_BUSINESS"] = "coin-pile-up-business";
  Assets["COMPLIANCE_PLATFORM"] = "compliance-platform";
  Assets["CONFETTI"] = "confetti";
  Assets["CONFETTI_BUSINESS"] = "confetti-business";
  Assets["CONSTRUCTION_FENCE"] = "construction-fence";
  Assets["CONTROLS_PLATFORM"] = "controls-platform";
  Assets["CONVERT"] = "convert";
  Assets["CONVERT_BUSINESS"] = "convert-business";
  Assets["COOKIE"] = "cookie";
  Assets["DIGITAL_CARD"] = "digital-card";
  Assets["DIGITAL_CARD_2"] = "digital-card-2";
  Assets["DIGITAL_CARD_BUSINESS"] = "digital-card-business";
  Assets["DOCUMENTS"] = "documents";
  Assets["DOCUMENTS_FOLDER_BUSINESS"] = "documents-folder-business";
  Assets["DOCUMENTS_SCAM"] = "documents-scam";
  Assets["DOOR"] = "door";
  Assets["ECO_CARD"] = "eco-card";
  Assets["ELECTRIC_PLUG"] = "electric-plug";
  Assets["EMAIL"] = "email";
  Assets["EMAIL_SCAM"] = "email-scam";
  Assets["EMAIL_SUCCESS"] = "email-success";
  Assets["EMAIL_SUCCESS_BUSINESS"] = "email-success-business";
  Assets["EXCLAMATION_MARK"] = "exclamation-mark";
  Assets["EXCLAMATION_MARK_BUSINESS"] = "exclamation-mark-business";
  Assets["FLAG"] = "flag";
  Assets["FLOWER"] = "flower";
  Assets["GEAR"] = "gear";
  Assets["GEAR_BUSINESS"] = "gear-business";
  Assets["GEAR_PLATFORM"] = "gear-platform";
  Assets["GET_PAID_WITH_CARD_BUSINESS"] = "get-paid-with-card-business";
  Assets["GIFT_BOX"] = "gift-box";
  Assets["GLOBE"] = "globe";
  Assets["GRAPH"] = "graph";
  Assets["GRAPH_BUSINESS"] = "graph-business";
  Assets["HEADSET"] = "headset";
  Assets["HEADSET_BUSINESS"] = "headset-business";
  Assets["HEADSET_SCAM"] = "headset-scam";
  Assets["HEART"] = "heart";
  Assets["HEART_2"] = "heart-2";
  Assets["HEART_3"] = "heart-3";
  Assets["HEART_4"] = "heart-4";
  Assets["HEART_5"] = "heart-5";
  Assets["HOUSE"] = "house";
  Assets["HOUSE_SCAM"] = "house-scam";
  Assets["ID_CARD"] = "id-card";
  Assets["ID_CARD_SCAM"] = "id-card-scam";
  Assets["INFINITE"] = "infinite";
  Assets["INTEREST"] = "interest";
  Assets["INVITE_LETTER"] = "invite-letter";
  Assets["JARS"] = "jars";
  Assets["KEY"] = "key";
  Assets["KEY_BUSINESS"] = "key-business";
  Assets["LIGHT_BULB"] = "light-bulb";
  Assets["LIGHT_BULB_BUSINESS"] = "light-bulb-business";
  Assets["LOCK"] = "lock";
  Assets["LOCK_BUSINESS"] = "lock-business";
  Assets["LOCK_PLATFORM"] = "lock-platform";
  Assets["MAGNIFYING_GLASS"] = "magnifying-glass";
  Assets["MAGNIFYING_GLASS_BUSINESS"] = "magnifying-glass-business";
  Assets["MAP"] = "map";
  Assets["MAP_BUSINESS"] = "map-business";
  Assets["MARBLE"] = "marble";
  Assets["MARBLE_BUSINESS"] = "marble-business";
  Assets["MARBLE_CARD"] = "marble-card";
  Assets["MARBLE_CARD_BUSINESS"] = "marble-card-business";
  Assets["MARBLE_CARD_BUSINESS_FLAG_ONLY"] = "marble-card-business-flag-only";
  Assets["MARBLE_CARD_FLAG_ONLY"] = "marble-card-flag-only";
  Assets["MARBLE_CARD_FLAG_ONLY_BUSINESS"] = "marble-card-flag-only-business";
  Assets["MEGAPHONE"] = "megaphone";
  Assets["MEGAPHONE_BUSINESS"] = "megaphone-business";
  Assets["MEGAPHONE_SCAM"] = "megaphone-scam";
  Assets["MULTI_CURRENCY"] = "multi-currency";
  Assets["MULTI_CURRENCY_BUSINESS"] = "multi-currency-business";
  Assets["ONE_INVITE_LETTER_OPENED"] = "one-invite-letter-opened";
  Assets["PALM_TREE"] = "palm-tree";
  Assets["PASSKEY"] = "passkey";
  Assets["PERCENTAGE"] = "percentage";
  Assets["PERCENTAGE_BUSINESS"] = "percentage-business";
  Assets["PERSON_RED_BLUE_SCAM"] = "person-red-blue-scam";
  Assets["PERSON_RED_SCAM"] = "person-red-scam";
  Assets["PERSONAL_CARD"] = "personal-card";
  Assets["PHONES"] = "phones";
  Assets["PIE_CHART"] = "pie-chart";
  Assets["PIE_CHART_BUSINESS"] = "pie-chart-business";
  Assets["PLANE"] = "plane";
  Assets["PLANE_2"] = "plane-2";
  Assets["PLANE_BUSINESS"] = "plane-business";
  Assets["PUZZLE_PIECES"] = "puzzle-pieces";
  Assets["PUZZLE_PIECES_BUSINESS"] = "puzzle-pieces-business";
  Assets["QUESTION_MARK"] = "question-mark";
  Assets["QUESTION_MARK_BUSINESS"] = "question-mark-business";
  Assets["QUESTION_MARK_SCAM"] = "question-mark-scam";
  Assets["RECEIVE"] = "receive";
  Assets["RECEIVE_BUSINESS"] = "receive-business";
  Assets["RECEIVE_SCAM"] = "receive-scam";
  Assets["RED_PACKET"] = "red-packet";
  Assets["REMINDER_LETTER"] = "reminder-letter";
  Assets["ROCKET_PLATFORM"] = "rocket-platform";
  Assets["SAND_TIMER"] = "sand-timer";
  Assets["SAND_TIMER_BUSINESS"] = "sand-timer-business";
  Assets["SATELLITE_PLATFORM"] = "satellite-platform";
  Assets["SHOPPING_BAG"] = "shopping-bag";
  Assets["SKIP_AUTHENTICATION"] = "skip-authentication";
  Assets["SKIP_AUTHENTICATION_SCAM"] = "skip-authentication-scam";
  Assets["SPEECH_BUBBLE"] = "speech-bubble";
  Assets["SPEECH_BUBBLE_SCAM"] = "speech-bubble-scam";
  Assets["STOPWATCH_PLATFORM"] = "stopwatch-platform";
  Assets["TARGET_PLATFORM"] = "target-platform";
  Assets["TOOL"] = "tool";
  Assets["TREASURY_PLATFORM"] = "treasury-platform";
  Assets["TWO_INVITE_LETTERS_OPENED"] = "two-invite-letters-opened";
  Assets["WALLET"] = "wallet";
})(Assets || (Assets = {}));
const illustration3DNames = ['check-mark', 'confetti', 'flower', 'globe', 'graph', 'interest', 'jars', 'lock', 'magnifying-glass', 'marble', 'marble-card', 'multi-currency', 'plane'];

function useBattery() {
  const [batteryData, setBatteryData] = useState({
    level: 1.0
  });
  useEffect(() => {
    const getBatteryData = async () => {
      // @ts-expect-error .getBattery exists in Navigator interface
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      const battery = await navigator.getBattery();
      setBatteryData({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        level: battery?.level
      });
    };
    // Check if the browser supports the Battery API
    if ('getBattery' in navigator && navigator.getBattery !== undefined && typeof navigator.getBattery === 'function') {
      void getBatteryData();
    }
  }, []);
  return batteryData;
}
function isBatteryLow(batteryLevel) {
  return batteryLevel < 0.2;
}
const isWebGL2Available = () => {
  try {
    const canvas = document.createElement('canvas');
    return !!(window.WebGL2RenderingContext && canvas.getContext('webgl2'));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return false;
  }
};
function isConnectionSlow() {
  // @ts-expect-error .connection prop exists in Navigator interface
  const {
    connection
  } = window.navigator;
  if (connection === undefined) {
    return false;
  }
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    ['slow-2g', '2g'].includes(connection?.effectiveType) ||
    // @ts-expect-error Property 'connection' does exist on type 'Navigator'
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    navigator?.connection?.saveData === true
  );
}
function defineSrc(asset) {
  return `https://wise.com/web-art/assets/illustrations3d/${asset}`;
}
const illustration3DSet = new Set(illustration3DNames);
function isIllustrationSupport3D(asset) {
  return illustration3DSet.has(asset);
}

/* eslint-disable fp/no-mutation */
var RenderMode;
(function (RenderMode) {
  RenderMode[RenderMode["INIT"] = 0] = "INIT";
  RenderMode[RenderMode["FALLBACK"] = 1] = "FALLBACK";
  RenderMode[RenderMode["ASSET_3D"] = 2] = "ASSET_3D";
})(RenderMode || (RenderMode = {}));
const Illustration3D = ({
  name,
  size = Sizes.MEDIUM,
  className
}) => {
  const [renderMode, setRenderMode] = useState(RenderMode.INIT);
  const [inintrinsicSize, setInintrinsicSize] = useState(size);
  const batteryData = useBattery();
  useEffect(() => {
    setRenderMode(isConnectionSlow() || isBatteryLow(batteryData.level) || !isWebGL2Available() ? RenderMode.FALLBACK : RenderMode.ASSET_3D);
    const isMobile = (typeof window !== undefined && window?.matchMedia('(max-width: 575px)')?.matches) ?? false;
    if (isMobile) {
      setInintrinsicSize(Sizes.SMALL);
    }
  }, [batteryData]);
  return /*#__PURE__*/jsx("div", {
    className: clsx(`wds-illustration-3d wds-illustration-3d-${name} wds-illustration-3d-${inintrinsicSize}`, className),
    "aria-hidden": true,
    children: renderMode === RenderMode.INIT ? null : renderMode === RenderMode.ASSET_3D ? /*#__PURE__*/jsx(Suspense, {
      fallback: null,
      children: getModel({
        name,
        size: inintrinsicSize
      })
    }) : /*#__PURE__*/jsx(Illustration, {
      name: name,
      size: size,
      alt: ""
    })
  });
};
function getModel({
  name,
  size
}) {
  // @ts-expect-error unknown generic
  let Model = /*#__PURE__*/jsx(Fragment, {});
  const Scene = /*#__PURE__*/lazy(async () => import('./Scene-BbP_hcsH.esm.js'));
  switch (name) {
    case Assets.LOCK:
      {
        Model = /*#__PURE__*/lazy(async () => import('./Lock-DQdry3N8.esm.js'));
        break;
      }
    case Assets.GLOBE:
      {
        Model = /*#__PURE__*/lazy(async () => import('./Globe-CYz_m8qY.esm.js'));
        break;
      }
    case Assets.CONFETTI:
      {
        Model = /*#__PURE__*/lazy(async () => import('./Confetti-CWZxburd.esm.js'));
        break;
      }
    case Assets.CHECK_MARK:
      {
        Model = /*#__PURE__*/lazy(async () => import('./CheckMark-BQNmIm2B.esm.js'));
        break;
      }
    case Assets.FLOWER:
      {
        Model = /*#__PURE__*/lazy(async () => import('./Flower-BiO5fjiT.esm.js'));
        break;
      }
    case Assets.PLANE:
      {
        Model = /*#__PURE__*/lazy(async () => import('./Plane-BYWAvZ3D.esm.js'));
        break;
      }
    case Assets.GRAPH:
      {
        Model = /*#__PURE__*/lazy(async () => import('./Graph-CFMO57zZ.esm.js'));
        break;
      }
    case Assets.MARBLE:
      {
        Model = /*#__PURE__*/lazy(async () => import('./Marble-cpxV1Xe8.esm.js'));
        break;
      }
    case Assets.MARBLE_CARD:
      {
        Model = /*#__PURE__*/lazy(async () => import('./MarbleCard-BL4Z4p0q.esm.js'));
        break;
      }
    case Assets.MAGNIFYING_GLASS:
      {
        Model = /*#__PURE__*/lazy(async () => import('./MagnifyingGlass-CirktDQ1.esm.js'));
        break;
      }
    case Assets.JARS:
      {
        Model = /*#__PURE__*/lazy(async () => import('./Jars-KgfjDdIn.esm.js'));
        break;
      }
    case Assets.MULTI_CURRENCY:
      {
        Model = /*#__PURE__*/lazy(async () => import('./MultiCurrency-Dug8SyTe.esm.js'));
        break;
      }
    case Assets.INTEREST:
      {
        Model = /*#__PURE__*/lazy(async () => import('./Interest-CgYb6-wb.esm.js'));
        break;
      }
  }
  return /*#__PURE__*/jsx(Scene, {
    assetName: name,
    size: size,
    children: /*#__PURE__*/jsx(Model, {})
  });
}

export { Assets as A, Flag as F, Illustration as I, Illustration3D as a, defineSrc as d, isIllustrationSupport3D as i };
//# sourceMappingURL=index-CAxCDj_E.esm.js.map
